import axios from "axios";
import { authHeaderAsync } from "../helpers/auth-header";

export const serviceService = {
    async getServices() {
        let response = await axios({
                method: "get",
                url: "/api/service",
                headers: await authHeaderAsync()
            });

        return response.data;
    },
    async updateService(service) {
        let response = await axios({
            method: "put",
            url: "/api/service",
            headers: await authHeaderAsync(),
            data: service
        });

        return response.data;
    },
    async confirmService(service) {
        let response = await axios({
            method: "post",
            url: "/api/service/confirm/"+service.id,
            headers: await authHeaderAsync(),
        });

        return response.data;
    },
    async createService(service) {
        let response = await axios({
            method: "post",
            url: "/api/service",
            headers: await authHeaderAsync(),
            data: service
        });

        return response.data;
    },
    async getServiceTypes() {
        let response = await axios({
            method: "get",
            url: "/api/servicetype",
            headers: await authHeaderAsync(),
        });

        return response.data;
    },
    async deleteServiceById(id) {
        let response = await axios({
            method: "delete",
            url: "/api/service/"+id,
            headers: await authHeaderAsync(),
        });

        return response.data;
    },
    async getServiceById(id) {
        try {
            let response = await axios({
                method: "get",
                url: "/api/service/" + id,
                headers: await authHeaderAsync(),
            });

            return response.data;
        } catch (error) {
            if(error.response.status === 404) {
                throw new Error("Leistungeintrag mit der ID " + id + " wurde nicht gefunden.");
            }
            throw error;
        }
    },
    async getQuery(query) {
        let response = await axios({
            method: "get",
            url: "/api/service/filter?"+query,
            headers: await authHeaderAsync(),
        });

        return response.data;
    }
}
